import { useEffect, useRef, memo } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { WithLoadingSpinner } from "@rentablo/components";
import { NoDataStub } from "@rentablo/components";
import { StackedBarChartSeries } from "../types";
import { useChartOptions } from "./useChartOptions";

type Props = {
  chartData?: StackedBarChartSeries[];
  height?: number;
  isLoading?: boolean;
  noDataMessage?: string;
};

export const StackedBarChart = memo(
  ({ chartData, height = 340, isLoading, noDataMessage }: Props) => {
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

    const chartOptions = useChartOptions(height, chartData);

    useEffect(() => {
      if (!chartComponentRef.current?.chart?.series[0]?.finishedAnimating)
        return;
      chartComponentRef.current.chart.reflow();
    }, [chartOptions]);

    return (
      <WithLoadingSpinner
        isLoading={Boolean(isLoading)}
        style={{ height: height }}
      >
        {!chartData?.length && !isLoading ? (
          <NoDataStub height="300px" secondLine={noDataMessage} />
        ) : (
          <HighchartsReact
            highcharts={Highcharts}
            ref={chartComponentRef}
            options={chartOptions}
            isLoading={Boolean(isLoading)}
          />
        )}
      </WithLoadingSpinner>
    );
  }
);
